// extracted by mini-css-extract-plugin
export var actionText = "_ko-4";
export var container = "_ko-0";
export var leftSection = "_ko-1";
export var rightSection = "_ko-2";
export var settingsButton = "_ko-6";
export var settingsIcon = "_ko-7";
export var shortcut = "_ko-5";
export var shortcutGroup = "_ko-3";